// react
import React from "react";

// react-router-dom
import { Route, Routes, useParams } from "react-router-dom";

// pages
import RequireAuth from "pages/RequireAuth";
import Signin from "pages/Signin";
import ResetPassword from "pages/ResetPassword";
import NewUser from "pages/NewUser";
import MyDataboxes from "pages/MyDataboxes";
import MyGroups from "pages/MyGroups";
import AccountSettings from "pages/AccountSettings";
import Databox from "pages/Databox";
import PublicTag from "pages/PublicTag";
import TagSettings from "pages/TagSettings";
import FlowMonitor from "pages/FlowMonitor";
import GroupSettings from "pages/GroupSettings";
import KeyPairGenerator from "pages/KeyPairGenerator";
import ResellerPanel from "pages/ResellerPanel";
import ClientList from "pages/ClientList";
import ClientSettings from "pages/ClientSettings";
import SimpleCertification from "pages/QuickSign/SimpleCertification";
import FileCertificationRequest from "pages/QuickSign/FileCertificationRequest";
import ErrorBoundary from "pages/ErrorBoundary";

// layout
import LayoutSwitcher from "layouts/LayoutSwitcher";

// A ---------------------------------------------------------------------- M

const LayoutSwitcherWithTag = (props) => {
  const { tag } = useParams();
  return <LayoutSwitcher tag={tag} {...props} />;
};

const App = () => {
  return (
    <Routes>
      <Route
        path="/signin"
        element={
          <LayoutSwitcher>
            <Signin />
          </LayoutSwitcher>
        }
      />

      <Route
        path="/reset-password"
        element={
          <LayoutSwitcher>
            <ResetPassword />
          </LayoutSwitcher>
        }
      />

      <Route
        path="/new-user"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <NewUser />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <MyDataboxes />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/my-groups"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <MyGroups />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/my-account"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <AccountSettings />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/:tag"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <Databox />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/:tag/public"
        element={
          <LayoutSwitcherWithTag>
            <PublicTag />
          </LayoutSwitcherWithTag>
        }
      />

      <Route
        path="/:tag/settings"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <TagSettings />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/:tag/monitor"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <FlowMonitor />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/:group/group-settings"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <GroupSettings />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/reseller-panel"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <ResellerPanel />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/keypair-generator"
        element={
          <LayoutSwitcher>
            <KeyPairGenerator />
          </LayoutSwitcher>
        }
      />

      <Route
        path="/customers"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <ClientList />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/customers/:customer"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <ClientSettings />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/customers"
        element={
          <RequireAuth>
            <LayoutSwitcher>
              <ClientList />
            </LayoutSwitcher>
          </RequireAuth>
        }
      />

      <Route
        path="/quicksign/simple-cert"
        element={
          <ErrorBoundary>
            <LayoutSwitcher>
              <SimpleCertification />
            </LayoutSwitcher>
          </ErrorBoundary>
        }
      />

      <Route
        path="/quicksign/file-cert-req"
        element={
          <ErrorBoundary>
            <LayoutSwitcher>
              <FileCertificationRequest />
            </LayoutSwitcher>
          </ErrorBoundary>
        }
      />
    </Routes>
  );
};

export default App;
